/**
 * Skeleton-компонент начальной загрузки для админа.
 */
export function LoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 px-4 pb-24">
      <div className="max-w-lg mx-auto space-y-6">
        {/* Skeleton заголовка */}
        <div className="text-center">
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/2 mx-auto" />
        </div>

        {/* Skeleton карточки заказа */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm space-y-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/4" />
            <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse w-1/5" />
          </div>

          {/* Venue */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse" />
            <div className="space-y-2 flex-1">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-3/4" />
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/2" />
            </div>
          </div>

          {/* Info rows */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-full" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-5/6" />
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-2/3" />
          </div>

          {/* Items */}
          <div className="border-t border-gray-200 dark:border-gray-700 pt-4 space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-gray-200 dark:bg-gray-700 animate-pulse" />
              <div className="space-y-2 flex-1">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-3/4" />
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/3" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-gray-200 dark:bg-gray-700 animate-pulse" />
              <div className="space-y-2 flex-1">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-2/3" />
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/4" />
              </div>
            </div>
          </div>

          {/* Totals */}
          <div className="border-t border-gray-200 dark:border-gray-700 pt-4 space-y-2">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-full" />
            <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse w-1/2" />
          </div>
        </div>
      </div>
    </div>
  );
}
